import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthenticatedRoute from './AuthenticatedRoute';
import ProtectedLoginRoute from './ProtectedLoginRoute';
import Login from '../pages/Login';
import LoginPhoneSet from '../pages/login/LoginPhoneSet';
import LoginPhoneVerify from '../pages/login/LoginPhoneVerify';
import LoginUpdatePhone from '../pages/login/LoginUpdatePhone';
import Register from '../pages/Register';
import ConfirmEmail from '../pages/register/ConfirmEmail';
import ConfirmKyc from '../pages/register/ConfirmKyc';

import EmailVerify from '../pages/forgotPassword/EmailVerify';
import PasswordReset from '../pages/forgotPassword/PasswordReset';
import ForgotPasswordSuccess from '../pages/forgotPassword/ForgotPasswordSuccess';
import HomePage from '../pages/HomePage';
import Faq from '../pages/Faq';
import TermsOfServices from '../pages/TermsOfServices';
import Policy from '../pages/Policy';
import Dashboard from '../pages/Dashboard';
import Account from '../pages/Account';
import History from '../pages/History';
import Rewards from '../pages/Rewards';
import Recharge from '../pages/Recharge';
import Transfer from '../pages/Transfer';
import Contact from '../pages/Contact';
import Layout from '../layouts/Layout';
import Assets from '../pages/Assets';
import SendToUser from '../pages/SendToUser';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login" element={<ProtectedLoginRoute />}>
          <Route path="phoneSet" element={<LoginPhoneSet />} />
          <Route path="phoneVerify" element={<LoginPhoneVerify />} />
          <Route path="updatePhone" element={<LoginUpdatePhone />} />
        </Route>

        <Route path="/register">
          <Route index element={<Register />} />
          <Route path="confirm-email/:email" element={<ConfirmEmail />} />
          <Route path="confirm-kyc/:id" element={<ConfirmKyc />} />
        </Route>

        <Route path="/forgotPassword">
          <Route index element={<EmailVerify />} />
          <Route path="reset" element={<PasswordReset />} />
          <Route path="success" element={<ForgotPasswordSuccess />} />
        </Route>

        <Route path="/" element={<HomePage />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/termsOfServices" element={<TermsOfServices />} />
        <Route path="/policy" element={<Policy />} />

        <Route
          path="/dashboard"
          element={
            <AuthenticatedRoute>
              <Layout />
            </AuthenticatedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="accounts" element={<Account />} />
          <Route path="history" element={<History />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="recharge" element={<Recharge />} />
          <Route path="transfer" element={<Transfer />} />
          <Route path="contact" element={<Contact />} />
          <Route path="assets" element={<Assets />} />
          <Route path="send" element={<SendToUser />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
